/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Same_Sex7Inputs */

const en__field_enum_same_sex7 = /** @type {(inputs: _Field_Enum_Same_Sex7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student/Pupil with same sex`)
};

const de__field_enum_same_sex7 = /** @type {(inputs: _Field_Enum_Same_Sex7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student:in/Schüler:in mit gleichem Geschlecht`)
};

/**
* | output |
* | --- |
* | "Student/Pupil with same sex" |
*
* @param {_Field_Enum_Same_Sex7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_same_sex7 = /** @type {((inputs?: _Field_Enum_Same_Sex7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Same_Sex7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_same_sex7(inputs)
	return de__field_enum_same_sex7(inputs)
});
export { _field_enum_same_sex7 as "_field_enum_SAME_SEX" }